import { Grid, Box } from "@chakra-ui/react";
import { useBreadcrumb } from "core/features/breadcrumbs";
import MenuDetalhes from "ui/components/Menu/MenuDetalhes";
import DashboardTab from "./DashboardTab";
import { useState } from "react";
import DadosCadastraisTab from "./DadosCadastraisTab";
import { useLocation } from "react-router-dom";
import FinanceiroTab from "./FinanceiroTab";
import Container from "components/Container";

export enum DashboardTabsRoutes {
  Dashboard = "dashboard",
  DadosCadastrais = "dados-cadastrais",
  Financeiro = "financeiro",
}

const tabs = [
  {
    label: "Dashboard",
    route: DashboardTabsRoutes.Dashboard,
    permissions: [],
  },
  {
    label: "Dados Cadastrais",
    route: DashboardTabsRoutes.DadosCadastrais,
    permissions: [],
  },
  {
    label: "Financeiro",
    route: DashboardTabsRoutes.Financeiro,
    permissions: [],
  },
];

function DashboardTabs() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const tab = params.get("tab") as DashboardTabsRoutes | null;
  const [selectedTab, setSelectedTab] = useState<DashboardTabsRoutes>(
    tab || DashboardTabsRoutes.Dashboard
  );
  useBreadcrumb([
    { name: "Financeiro", url: "/financeiro/dashboard" },
    { name: "Dashboard", url: "/financeiro/dashboard" }    
  ]);

  return (
    <Container>
      <Grid templateColumns="1fr 4fr" gridGap={4} mt={8}>
        <Box h="fit-content">
          <MenuDetalhes
            options={tabs}
            selectedOption={selectedTab}
            onChangeOption={(tab) => {
              setSelectedTab(tab);
            }}
          />
        </Box>

        <Box>
          {selectedTab === DashboardTabsRoutes.Dashboard ? (
            <DashboardTab />
          ) : null}

          {selectedTab === DashboardTabsRoutes.DadosCadastrais ? (
            <DadosCadastraisTab />
          ) : null}

          {selectedTab === DashboardTabsRoutes.Financeiro ? (
            <FinanceiroTab />
          ) : null}
        </Box>
      </Grid>
    </Container>
  );
}

export default DashboardTabs;
